import React from 'react'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/receivement/ReceivementState'
import { useSelector } from 'src/utils/store'
import * as S from './ModalObservation.styles'

interface Props {
  maxLength: number;
}

const MAX_LENGTH = 400

const ModalObservationInput = ({ maxLength }: Props) => {
  const dispatch = useDispatch()

  const { observation } = useSelector((state) => state.receivement.observation)

  const handleCharactersRemaining = React.useMemo(() => {
    const charactersRemaining = MAX_LENGTH - observation.length

    if (charactersRemaining === 1) {
      return 'Resta 1 caractere.'
    }
    if (charactersRemaining > 1) {
      return `Restam ${charactersRemaining} caracteres.`
    }

    return ''
  }, [observation.length])

  const handleObservation = React.useCallback(
    (value: string) => {
      dispatch(actions.setObservation(value))
    },
    [dispatch],
  )

  return (
    <S.InputContainer>
      <S.Input
        data-testid='modal-observation-input'
        value={observation}
        rows={6}
        maxLength={maxLength}
        onChange={(e) => handleObservation(e.target.value)}
      />
      <S.CharactersRemainingContainer>
        <S.CharactersRemainingText>{handleCharactersRemaining}</S.CharactersRemainingText>
      </S.CharactersRemainingContainer>
    </S.InputContainer>
  )
}

export default React.memo(ModalObservationInput)
